module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMRJREFUeNpiYKA12HLKfz2UdgBhZDFsgBGHIQJAaj4QByAJfwDiA0Cc6GO28QO6HhYcFuwHYgM0MQGowQpAbIiugQmLaxKwGILsKgOoGvwGAYE9nqATwKWGEckl56HOPoAWNtjAA6ihD4DhZYgeRgZotuIDCmh6sHqNLDA0DPpAhD68CdIRGogKRMTaBSBeCI097FkEmAxAhqwnYFAgMNo3EMxrUANB2QSUWRuhQvWgNAY0wJGmgc1CRIBeIDEiKAMAAQYAv98yT2gke0YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/appdownicon/androidapp.png
// module id = QEa1
// module chunks = 129